import styled from 'styled-components';

export const AdditionalChargesWrapperDiv = styled.div(
  props => `
    width:100%;
    display: flex;
    flex-direction: column;
    background-color:#ffebee;
    border-radius: 0.8rem;
    padding:1rem;
    margin: ${props.isMweb ? '1rem 0 1.2rem' : '1rem 0 2rem'};
    .upECArrow{transform:rotate(180deg)};
    `,
);

export const PanWarningText = styled.span(
  props => `
    color: #736C56;
    `,
);
